export default __webpack_public_path__ + "static/media/Parrilla-orange.d87025b5.svg";